export default __webpack_public_path__ + "static/setup_jag_monitor-8a0841e6f2cf361fdccf70390b2fbc9a.png";